import React, {useEffect, useState} from 'react';
import {FormPageRoot, ThemedButton, ThemedIconButton, ThemedInput} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    createTimeout,
    focusElement,
    getArrLen,
    getCurrUrlParamValue,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isArr,
    isBoolTrue,
    isJsonValueTrue,
    jsonToStr
} from "../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {useLocation, useNavigate} from "react-router-dom";
import {
    EVENT_INPUT_MAX_LEN,
    GenRouteUrls,
    INPUT_FILE_MAX_SIZE,
    ModuleFieldsData,
    Modules,
    ReqUrls,
    ShowViewType,
    SurveyDateTimeTypes as DATE_TIME_TYPES,
    SurveyQTypes as Q_TYPES,
} from "../../../config/AppConfig";
import {Avatar, Checkbox, Flexbox, GridBox, Label, LikertView, MsgBox, Section, Select} from "../../../../common/fusion-ui";
import {Constants, CssVariant, IconClass, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {useInternetStatus} from "../../../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../../../common/CommonConfig";

const Survey_AddEditQsPage = React.memo(({
                                             updateOnly,
                                             open,
                                             onHide,
                                             recordId,
                                             surveyId,
                                             showAs = ShowViewType.PAGE,
                                             onSuccess,

                                         }) => {
    const TAG = "Survey_AddEditQsPage";

    const moduleName = Modules.Survey;

    const mf = ModuleFieldsData[Modules.Survey_ViewQs];
    const mf_srv = ModuleFieldsData[Modules.Survey];

    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();
    // const {isScreenXs, isScreenSm, isScreenMd, isScreenResizing} = useScreenSize();

    const FOCUS_DELAY = 2000;

    const Fields = {
        recordId: 'recordId',
        surveyId: 'surveyId',

        isUpdateModeDataFetched: 'isUpdateModeDataFetched',
        isAddModeDataFetched: 'isAddModeDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    const [formData, setFormData] = useState({});
    // const [formData, setFormData] = useState(Survey_AddEditQsPage_Data);
    const [srvRecordData, setSrvRecordData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        // log('useEffect.showAs:', showAs, 'recordId:', recordId, 'surveyId:', surveyId, 'updateOnly:', updateOnly);
        if (showAs == ShowViewType.PAGE) {
            const qId = getCurrUrlParamValue('id');
            const sId = getCurrUrlParamValue('sid');
            log('useEffect.showAs->PAGE:', showAs, 'qId:', qId, 'sId:', sId, 'updateOnly:', updateOnly);
            if (isBoolTrue(updateOnly)) {
                fetchEditModeData(qId, sId);
            } else {
                fetchAddModeData(sId);
            }
        } else {
            // setFormData({});
            // setSrvRecordData({});
            // setFieldsData({});
            if (checkNullStr(recordId) && checkNullStr(surveyId)) {
                log('useEffect.showAs-Popup->', 'recordId:', recordId, 'surveyId:', surveyId, 'updateOnly:', updateOnly);
                if (isBoolTrue(updateOnly)) {
                    fetchEditModeData(recordId, surveyId, true);//true for testing only
                } else {
                    fetchAddModeData(surveyId, true);//true for testing only
                }
            }
        }
    }, [recordId, surveyId, showAs, updateOnly]);

    return (<>
        <FormPageRoot
            tag={TAG}
            moduleName={Modules.Survey_ViewQs}
            addPageTitle={getTabTitle()}
            editPageTitle={getTabTitle()}
            updateOnly={isUpdateMode()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            backUrl={`${GenRouteUrls.survey_viewQsPage}${getField(Fields.surveyId)}`}
            open={open}
            onHide={() => {
                if (onHide) onHide();
                clearPanelData();
            }}
            showAs={showAs}
            md={6}>
            <div>
                {createPanel()}
            </div>
        </FormPageRoot>
    </>);

    function createPanel() {
        return <div className={`h-auto m-0 p-0 mt-2`}>

            {/*survey-name*/}
            <div>
                <Label className={`m-0 p-0 text-wrap fw-semi-bold x`} textAt={'start'} color={theme.text60}>
                    <span>Survey Name:</span>
                    <span className={'text-primary ps-1 fw-bold'}>
                            {getJsonValue(srvRecordData, mf_srv.title.column)}
                        </span>
                </Label>
            </div>

            <div className={'w-100 m-0 p-0 mt-3'}>
                {/*q-input*/}
                <div className={'w-100 m-0 p-0'}>
                    {/*question*/}
                    <ThemedInput
                        wrapperClassName={'mt-1'}
                        className={''}
                        label={mf.question.title}
                        placeholder={mf.question.title}
                        id={mf.question.column}
                        type={'text'}
                        value={getFormField(mf.question)}
                        msg={getFormFieldMsg(mf.question)}
                        showLimitLabel={true}
                        maxLength={EVENT_INPUT_MAX_LEN}
                        required={true}
                        onChange={(e) => {
                            const value = e.target.value;
                            updateFormField(mf.question, value);
                            if (checkNullStr(value)) updateFormFieldMsg(mf.question, '');
                        }}
                    />
                </div>

                {/*image*/}
                <GridBox className={'mt-1x px-2'} sm={12} md={[3, 9]} gap={1}>
                    {/*add-image*/}
                    <ThemedButton
                        className={'w-auto px-2 py-1 text-nowrap'}
                        text={isFormFieldTrue(mf.showImage) ? 'Remove Image' : 'Add Image'}
                        variant={theme.primaryAlt}
                        hoverBgColor={theme.primaryAltDark}
                        height={'28px'}
                        onClick={() => {
                            updateFormField(mf.showImage, !isFormFieldTrue(mf.showImage));
                            if (!isFormFieldTrue(mf.showImage)) {
                                updateFormField(mf.image, null);
                            }
                        }}
                    />

                    {isFormFieldTrue(mf.showImage) && <Avatar
                        wrapperClassName={'ms-3x'}
                        className={''}
                        justifyAt={'start'}
                        accept={'.pdf, .jpg, .jpeg, .png'}
                        editTooltip={`Edit (.pdf, .jpg, .jpeg, .png)`}
                        showEdit={true}
                        showDelete={true}
                        circular={false}
                        disableImgDrag={!checkNullStr(getFormField(mf.image))}
                        defAvatarImg={Constants.imgVector}
                        editSize={'21px'}
                        width={'200px'}
                        height={'auto'}
                        maxSize={INPUT_FILE_MAX_SIZE}
                        onChange={(e, file, path, name, ext) => {
                            //log('Avatar.doc.onChange.name:', name);
                            updateFormField(mf.image, file);
                            updateFormField(mf.imageFileExt, ext);
                        }}
                        onInvalidFormat={(e, name) => {
                            toast(`Invalid file format. File must be pdf, jpg, jpeg or png`, CssVariant.danger);
                        }}
                        onSizeExceeded={() => {
                            toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                        }}>{getFormField(mf.image)}</Avatar>}
                </GridBox>

                {/*link*/}
                <GridBox className={'mt-3 px-2'} sm={12} md={[3, 9]} gap={1}>
                    {/*add-link*/}
                    <ThemedButton
                        className={'w-auto px-2 py-1 text-nowrap'}
                        text={isFormFieldTrue(mf.showLink) ? 'Remove Link' : 'Add Link'}
                        variant={theme.primaryAlt}
                        hoverBgColor={theme.primaryAltDark}
                        height={'29px'}
                        onClick={() => {
                            if (!isFormFieldTrue(mf.showLink)) {
                                updateFormField(mf.link, null);
                            } else {
                            }
                            updateFormField(mf.showLink, !isFormFieldTrue(mf.showLink));
                            createTimeout(() => {
                                focusElement(mf.link.column, 'id');
                            }, 200);
                        }}
                    />

                    {/*link*/}
                    {isFormFieldTrue(mf.showLink) && <ThemedInput
                        wrapperClassName={'ms-2x mt-n1'}
                        mainWrapperClassName={'w-100'}
                        label={''}
                        placeholder={mf.link.title}
                        id={mf.link.column}
                        type={'text'}
                        value={getFormField(mf.link)}
                        msg={getFormFieldMsg(mf.link)}
                        style={{height: '30px'}}
                        required={true}
                        showMsg={false}
                        onChange={(e) => {
                            const value = e.target.value;
                            updateFormField(mf.link, value);
                            if (checkNullStr(value)) updateFormFieldMsg(mf.link, '');
                        }}
                    />}
                </GridBox>

                {/*q-type select & their layouts*/}
                <div className={'m-0 p-0 mt-3'}>
                    {/*questionType select*/}
                    <div>
                        <Select
                            id={mf.answerType.column}
                            wrapperClassName={`w-100`}
                            labelClassName={`px-1 w-100 text-input-label`}
                            innerWrapperClassName={'w-100'}
                            className={`w-100 py-2 rounded-3`}
                            variant={'primary'}
                            justifyAt={'start'}
                            // style={{height: INPUT_H}}
                            labelStyle={{color: theme.text40}}
                            label={'Question type'}
                            placeholder={'Select a question type'}
                            textKey={"name"}
                            idKey={"value"}
                            options={Object.values(Q_TYPES).map(item => ({name: getJsonValue(item, 'name'), value: getJsonValue(item, 'value')}))}
                            defOption={getFormField(mf.answerType)}
                            onChange={(e, text, value) => {
                                updateFormField(mf.answerType, value);
                                updateFormField(mf.answerTypeName, text);
                                if (!isUpdateMode()) {
                                    updateFormField(mf.rangeStart, null);
                                    updateFormField(mf.rangeEnd, null);
                                    updateFormField(mf.answerType_cb_radio_InputValue, null);
                                    updateFormField(mf.answerType_multipleChoice, null);
                                    updateFormField(mf.answerType_checkbox, null);
                                    updateFormField(mf.answerType_dateTimeType, null);
                                    updateFormField(mf.answerType_Likert_LikertData, null);
                                }
                            }}
                        />
                    </div>

                    {/*select-type-view/s*/}
                    <div className={'p-0 m-0 w-100 mt-3'}>
                        {/*1,2: textarea, paragraph*/}
                        {(getFormField(mf.answerType) == Q_TYPES.textarea.value || getFormField(mf.answerType) == Q_TYPES.paragraph.value)
                            && <ThemedInput
                                wrapperClassName={''}
                                type={'text'}
                                placeholder={'Respondent will type here'}
                                // disabled={true}
                                readOnly={true}
                                asTextArea={true}
                                style={{
                                    height: '120px',
                                    maxHeight: '120px',
                                    minHeight: '120px',
                                }}
                            />}

                        {/*3. multipleChoice-radio-list*/}
                        {(getFormField(mf.answerType) == Q_TYPES.multipleChoice.value
                                || getFormField(mf.answerType) == Q_TYPES.checkboxes.value) &&
                            <Section className={'w-100 m-0 p-0x mt-3 h-auto pb-3 app-section'}
                                     title={getFormField(mf.answerTypeName) + (checkNullArr(getFormField(get_Cb_Radio_ListKeyField())) ? ' Preview' : '')}
                                     titleAt={'start'}
                                     titleColor={theme.text80}
                                     borderColor={theme.text20}
                                     roundedVariant={4}
                                     titleClassName={'fw-normal'}>
                                {/*radio/cb-list*/}
                                {checkNullArr(getFormField(get_Cb_Radio_ListKeyField())) &&
                                    getFormField(get_Cb_Radio_ListKeyField()).map((cbItem, index) => {
                                        return <Flexbox className={''} justifyAt={'start'} alignAt={'center'}
                                                        key={index + getJsonValue(cbItem, 'name')}>
                                            {/*radio*/}
                                            <Checkbox
                                                wrapperClassName={`w-100 mb-1`}
                                                className={``}
                                                type={isQType_RadioChoice() ? 'radio' : 'checkbox'}
                                                labelStyle={{color: theme.text}}
                                                // defaultChecked={isQType_RadioChoice() ? false : getCbList().includes(cbItem + '')}
                                                // defaultChecked={isQType_RadioChoice() ? false : getCbList().includes(cbItem + '')}
                                                // checked={getCbList().find(findItem => getJsonValue(findItem, 'name') === getJsonValue(cbItem, 'name') && isJsonValueTrue(findItem, 'selected'))}
                                                checked={isJsonValueTrue(cbItem, 'selected')}
                                                disabled={isQType_RadioChoice()}
                                                onChange={(e, checked) => {
                                                    const fun = 'cbRadioList.onChange:';

                                                    const listKey = get_Cb_Radio_ListKeyField();
                                                    const cbList = getFormField(listKey, []);
                                                    log(fun, 'listKey:', listKey, 'cbList:', cbList, 'checked:', checked);
                                                    try {
                                                        if (checkNullArr(cbList)) {
                                                            const updatedList = [];
                                                            cbList.map((thisItem) => {
                                                                updatedList.push({
                                                                    ...thisItem,
                                                                    selected: getJsonValue(thisItem, 'name') == getJsonValue(cbItem, 'name') ? checked : isJsonValueTrue(thisItem, 'selected')
                                                                });
                                                            })
                                                            updateFormField(listKey, updatedList);
                                                            log(fun, 'updatedList-later:', updatedList);
                                                        } else {
                                                            updateFormField(listKey, []);
                                                        }
                                                    } catch (e) {
                                                        toast('Selection failed, please try again!', CssVariant.danger);
                                                        logErr(e);
                                                    }
                                                }}>{jsonToStr(getJsonValue(cbItem, 'name'))}</Checkbox>
                                            {/*remove-btn*/}
                                            <ThemedIconButton
                                                className={'p-0 '}
                                                ml={1}
                                                mt={'n1'}
                                                size={'24px'}
                                                variant={theme.text}
                                                bgColor={'transparent'}
                                                hoverBgColor={theme.text10}
                                                color={theme.text80}
                                                hoverColor={theme.text}
                                                rippleColor={theme.text20}
                                                icon={IconClass.minusCircle}
                                                tooltip={'Remove'}
                                                circular={true}
                                                onClick={() => {
                                                    const listKey = get_Cb_Radio_ListKeyField();
                                                    let list = getFormField(listKey, []);
                                                    log('listKey:', listKey, '.map.plus.onClick.list:', list, 'len:', getArrLen(list));
                                                    try {
                                                        if (checkNullArr(list)) {
                                                            list = list.filter(listItem => getJsonValue(listItem, 'name') != getJsonValue(cbItem, 'name'));
                                                            updateFormField(listKey, list);
                                                            log('listKey:', listKey, '.map.plus.onClick.list-after:', list, 'len:', getArrLen(list));
                                                            focusElement(mf.answerType_cb_radio_InputValue.column, 'id');
                                                        }
                                                    } catch (e) {
                                                        logErr(e);
                                                        toast("Couldn't delete new cbItem, please try again")
                                                    }
                                                }}
                                            />
                                        </Flexbox>
                                    })}

                                {/*add-item-input*/}
                                <Flexbox className={'mt-1'} justifyAt={'start'} alignAt={'start'}>
                                    {/*input*/}
                                    <ThemedInput
                                        mainWrapperClassName={'w-100'}
                                        wrapperClassName={'mt-n1'}
                                        className={''}
                                        label={''}
                                        placeholder={'Add Item'}
                                        style={{height: '30px'}}
                                        id={mf.answerType_cb_radio_InputValue.column}
                                        type={'text'}
                                        value={getFormField(mf.answerType_cb_radio_InputValue)}
                                        required={true}
                                        showMsg={false}
                                        onChange={(e) => {
                                            updateFormField(mf.answerType_cb_radio_InputValue, e.target.value);
                                        }}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter') {
                                                log('Input enter pressed');
                                                addItemInCbOrRadioList(getFormField(mf.answerType_cb_radio_InputValue));
                                            }
                                        }}
                                    />
                                    {/*add-btn*/}
                                    <ThemedButton
                                        className={'px-3 w-auto py-1 fs-sm fw-semi-bold'}
                                        ml={2}
                                        height={'28px'}
                                        outlined={true}
                                        variant={theme.primaryBlue}
                                        text={`Add`}
                                        onClick={() => {
                                            addItemInCbOrRadioList(getFormField(mf.answerType_cb_radio_InputValue));
                                        }}
                                    />
                                </Flexbox>
                            </Section>}

                        {/*4. slider-range*/}
                        {(getFormField(mf.answerType) == Q_TYPES.sliderRange.value) &&
                            <Section className={'w-100 m-0 p-0x mt-3 h-auto pb-3 app-section'}
                                     title={getFormField(mf.answerType)}
                                     titleAt={'start'}
                                     titleColor={theme.text80}
                                     borderColor={theme.text20}
                                     roundedVariant={4}
                                     titleClassName={'fw-normal'}>
                                <Flexbox className={'mt-1'} alignAt={'center'} justifyAt={'start'}>
                                    {/* start-range */}
                                    <ThemedInput
                                        mainWrapperClassName={'me-2'}
                                        wrapperClassName={''}
                                        className={''}
                                        label={'Add Start Range'}
                                        placeholder={'Enter Start Range'}
                                        id={mf.rangeStart.column}
                                        type={'text'}
                                        // pattern={Patterns.plainNumber}
                                        // validate={true}
                                        value={getFormField(mf.rangeStart)}
                                        msg={getFormFieldMsg(mf.rangeStart)}
                                        required={true}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.rangeStart, value);
                                            if (checkNullStr(value)) updateFormFieldMsg(mf.rangeStart, '');
                                        }}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter') {
                                                if (checkNullStr(getFormField(mf.rangeStart))) {
                                                    focusElement(mf.rangeEnd.column, 'id');
                                                } else {
                                                    focusElement(mf.rangeStart.column, 'id');
                                                }
                                            }
                                        }}
                                    />

                                    {/* end-range */}
                                    <ThemedInput
                                        mainWrapperClassName={'ms-2'}
                                        className={''}
                                        label={'Add End Range'}
                                        placeholder={'Enter End Range'}
                                        id={mf.rangeEnd.column}
                                        type={'text'}
                                        // pattern={Patterns.plainNumber}
                                        // validate={true}
                                        value={getFormField(mf.rangeEnd)}
                                        msg={getFormFieldMsg(mf.rangeEnd)}
                                        required={true}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.rangeEnd, value);
                                            if (checkNullStr(value)) updateFormFieldMsg(mf.rangeEnd, '');
                                        }}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter') {
                                                if (!checkNullStr(getFormField(mf.rangeEnd))) {
                                                    focusElement(mf.rangeEnd.column, 'id');
                                                } else if (!checkNullStr(getFormField(mf.rangeStart))) {
                                                    focusElement(mf.rangeStart.column, 'id');
                                                }
                                            }
                                        }}
                                    />
                                </Flexbox>
                            </Section>}

                        {/*5. date-time*/}
                        {(getFormField(mf.answerType) == Q_TYPES.dateTime.value) &&
                            <Section className={'w-100 m-0 p-0x mt-3 h-auto pb-3x app-section'}
                                     title={getFormField(mf.answerType)}
                                     titleAt={'start'}
                                     titleColor={theme.text80}
                                     borderColor={theme.text20}
                                     roundedVariant={4}
                                     titleClassName={'fw-normal'}>
                                <div className={'w-100 m-0 p-0'}>
                                    {/*date-time*/}
                                    <Checkbox
                                        wrapperClassName={`w-100 mb-1`}
                                        className={``}
                                        type={'radio'}
                                        labelStyle={{color: theme.text}}
                                        defaultChecked={getFormField(mf.answerType_dateTimeType) == DATE_TIME_TYPES.dateTime}
                                        checked={getFormField(mf.answerType_dateTimeType) == DATE_TIME_TYPES.dateTime}
                                        onChange={(e, checked) => {
                                            updateFormField(mf.answerType_dateTimeType, DATE_TIME_TYPES.dateTime);
                                        }}>{DATE_TIME_TYPES.dateTime}</Checkbox>

                                    {/*date-only*/}
                                    <Checkbox
                                        wrapperClassName={`w-100 mb-1`}
                                        className={``}
                                        type={'radio'}
                                        labelStyle={{color: theme.text}}
                                        defaultChecked={getFormField(mf.answerType_dateTimeType) == DATE_TIME_TYPES.date}
                                        checked={getFormField(mf.answerType_dateTimeType) == DATE_TIME_TYPES.date}
                                        onChange={(e, checked) => {
                                            updateFormField(mf.answerType_dateTimeType, DATE_TIME_TYPES.date);
                                        }}>{DATE_TIME_TYPES.date}</Checkbox>

                                    {/*time-only*/}
                                    <Checkbox
                                        wrapperClassName={`w-100 mb-1`}
                                        className={``}
                                        type={'radio'}
                                        labelStyle={{color: theme.text}}
                                        defaultChecked={getFormField(mf.answerType_dateTimeType) == DATE_TIME_TYPES.time}
                                        checked={getFormField(mf.answerType_dateTimeType) == DATE_TIME_TYPES.time}
                                        onChange={(e, checked) => {
                                            updateFormField(mf.answerType_dateTimeType, DATE_TIME_TYPES.time);
                                        }}>{DATE_TIME_TYPES.time}</Checkbox>
                                </div>
                            </Section>}

                        {/*6. Likert*/}
                        {(getFormField(mf.answerType) == Q_TYPES.likert.value) &&
                            <Section className={'w-100 m-0 p-0x mt-3 h-auto pb-3 app-section'}
                                     title={getFormField(mf.answerType.title)}
                                     titleAt={'start'}
                                     titleColor={theme.text80}
                                     borderColor={theme.text20}
                                     roundedVariant={4}
                                     titleClassName={'fw-normal'}>
                                <LikertView
                                    borderColor={theme.text20}
                                    color={theme.text}
                                    data={getFormField(mf.answerType_Likert_LikertData, [])}
                                    roundedVariant={3}
                                    onUpdate={(updatedData) => {
                                        log('LikertView.onUpdate.updatedData:', updatedData);
                                        updateFormField(mf.answerType_Likert_LikertData, updatedData);
                                    }}
                                />
                            </Section>}
                    </div>
                </div>

                {/*submit, cancel controls*/}
                <div className={'mt-3'}>
                    {/*msg-box*/}
                    {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                        {getField(Fields.panelMsg)}
                    </MsgBox>}

                    <Flexbox justifyAt={'center'} alignAt={'center'}>
                        {/*cancel*/}
                        {(showAs == ShowViewType.DRAWER || showAs == ShowViewType.DIALOG) && <ThemedButton
                            className={'rounded-2 w-auto px-4 py-1'}
                            text={'Cancel'}
                            variant={theme.text10}
                            hoverBgColor={theme.text30}
                            color={theme.text}
                            onClick={() => {
                                if (onHide) onHide();
                                clearPanelData();
                            }}
                            mx={2}
                        />}

                        {/*submit*/}
                        <ThemedButton
                            className={'rounded-2 w-auto px-4 py-1'}
                            text={isFieldTrue(Fields.submitBtn_AsLoading)
                                ? isUpdateMode() ? 'Updating...' : 'Submitting...'
                                : isUpdateMode() ? 'Update' : 'Submit'}
                            variant={theme.primaryBlue}
                            hoverBgColor={theme.primaryBlueDark}
                            loadingWidth={'auto'}
                            asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                            disabled={isFieldTrue(Fields.submitBtn_disabled)}
                            onClick={handleSubmit}
                            mx={2}
                        />
                    </Flexbox>
                </div>
            </div>
        </div>

        function isQType_RadioChoice() {
            return getFormField(mf.answerType) == Q_TYPES.multipleChoice.value;
        }

        function get_Cb_Radio_ListKeyField() {
            return isQType_RadioChoice() ? mf.answerType_multipleChoice : mf.answerType_checkbox;
        }

        function addItemInCbOrRadioList(inputValue) {
            const fun = 'addItemInCbOrRadioList:';
            try {
                const listKeyField = get_Cb_Radio_ListKeyField();
                // let inputValue = getFormField(mf.answerType_cb_radio_InputValue) + '';
                inputValue = inputValue + '';
                // log(fun, 'listKeyField:', listKeyField, 'inputValue:', inputValue);
                if (checkNullStr(inputValue)) {
                    let list = getFormField(listKeyField, []);
                    // log(fun, 'inputValue:', inputValue, 'list:', list);
                    try {
                        if (isArr(list)) {
                            if (list.some(item => (getJsonValue(item, 'name') + '').toLowerCase().trim() == inputValue.toLowerCase().trim())) {
                                toast('Already added', CssVariant.warning);
                            } else {
                                list.push({name: inputValue.trim(), selected: false});
                                updateFormField(listKeyField, list);
                                updateFormField(mf.answerType_cb_radio_InputValue, '');
                            }
                        }
                    } catch (e) {
                        logErr(fun, e);
                        toast("Couldn't add new item, please try again!", CssVariant.danger);
                    }
                }
                focusElement(mf.answerType_cb_radio_InputValue.column, 'id');
            } catch (error) {
                logErr(fun, error);
            }
        }
    }

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }
        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.recordId),
                    surveyId: getField(Fields.surveyId),
                    formData: formData,
                };
                sendRequest({
                    reqUrl: ReqUrls.survey__addEditQsPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                redirectPage();
                            } else {
                                createTimeout(() => {
                                    clearPanelData();
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchEditModeData(recordId, surveyId, checkBefore = true) {
        const fun = 'fetchEditModeData:';
        try {
            log(fun, 'recordId:', recordId, 'surveyId:', surveyId);
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isUpdateModeDataFetched))) {
                updateField(Fields.isUpdateModeDataFetched, true);
                updateField(Fields.surveyId, surveyId);
                updateField(Fields.recordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                        surveyId: surveyId,
                    };
                    sendRequest({
                        reqUrl: ReqUrls.survey__addEditQsPage_fetch_editFormData,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);//surveyRecord, qRecord

                            const fetchedSrvRecord = getJsonValueFromNestedKeys(fetchedData, ['data', 'surveyRecord'], {});
                            const fetchedQRecord = getJsonValueFromNestedKeys(fetchedData, ['data', 'qRecord'], {});

                            const message = getJsonValue(fetchedData, 'message');
                            const success = checkNullJson(fetchedQRecord);

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                // toast(message, CssVariant.success);
                                setSrvRecordData(fetchedSrvRecord);
                                setFormData(fetchedQRecord);
                            } else {
                                toast(message, CssVariant.danger);
                                updateField(Fields.dataLoadingMsg, message);
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            toast(Messages.fetchError, CssVariant.danger);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            toast(Messages.fetchError, CssVariant.danger);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    async function fetchAddModeData(surveyId, checkBefore = true) {
        const fun = 'fetchAddModeData:';
        try {
            log(fun, 'surveyId:', surveyId, 'isAddModeDataFetched:', isFieldTrue(Fields.isAddModeDataFetched));
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isAddModeDataFetched))) {
                updateField(Fields.isAddModeDataFetched, true);
                updateField(Fields.surveyId, surveyId);
                if (checkNullStr(surveyId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");
                    setSrvRecordData({});

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: surveyId,
                    };
                    sendRequest({
                        reqUrl: ReqUrls.survey__addEditPage_fetch_editFormData,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);
                            const fetchedSrvRecord = getJsonValue(fetchedData, 'data', {});
                            const success = checkNullJson(fetchedSrvRecord);

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                setSrvRecordData(fetchedSrvRecord);
                            } else {
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            toast("Couldn't load data, please try again!", CssVariant.danger);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Survey-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            toast("Couldn't load data, please try again!", CssVariant.danger);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${Modules.Survey_ViewQs}' page now...`);
            createTimeout(() => {
                window.location.href = `${GenRouteUrls.survey_viewQsPage}${getField(Fields.surveyId)}`;
            }, 2500);
        }, 500);
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            mf.question,
        ];
        if (isFormFieldTrue(mf.showImage)) requiredFields.push(mf.image);
        if (isFormFieldTrue(mf.showLink)) requiredFields.push(mf.link);
        if (isFormFieldTrue(mf.showLink)) requiredFields.push(mf.link);
        requiredFields.push(mf.answerType);

        if (getFormField(mf.answerType) == Q_TYPES.multipleChoice.value) requiredFields.push(mf.answerType_multipleChoice);
        if (getFormField(mf.answerType) == Q_TYPES.checkboxes.value) requiredFields.push(mf.answerType_checkbox);
        if (getFormField(mf.answerType) == Q_TYPES.sliderRange.value) {
            requiredFields.push(mf.rangeStart);
            requiredFields.push(mf.rangeEnd);
        }
        // if (getFormField(mf.answerType) == Q_TYPES.dateTime.value) requiredFields.push(mf.answerType_dateTimeType);
        if (getFormField(mf.answerType) == Q_TYPES.likert.value) requiredFields.push(mf.answerType_Likert_LikertData);

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            // if (field.column==mf.sliderRange.column) {
            //     if (!checkNullStr(formData[field.column])){
            //
            //     }
            // }else
            if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colField.title}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function getTabTitle() {
        return isUpdateMode() ? `Update Survey Question` : `Create Survey Question`;
    }

    function clearPanelData() {
        setFormData({});
        setSrvRecordData({});
        setFieldsData({});
        setFormFieldsMsgs({});
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Survey_AddEditQsPage;
